// import styles
import { alpha } from "@mui/material/styles";
import { QUINTUPLE_DECILE, TRIPLE } from "../../../constants/numbers.consts.js";
import { SCROLLBAR_WIDTH_DEFAULT, THUMB_OPACITY, THUMB_BORDER_WIDTH_DEFAULT, SCROLLBAR_HEIGHT_DEFAULT, THUMB_OPACITY_ON_HOVER, } from "../../../constants/scrollbar.consts.js";
export default {
    styleOverrides: (theme) => ({
        html: {
            "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
                width: theme.spacing(SCROLLBAR_WIDTH_DEFAULT),
                height: theme.spacing(SCROLLBAR_HEIGHT_DEFAULT),
            },
            "&::-webkit-scrollbar-track, & *::-webkit-scrollbar-track": {
                background: theme.palette.common.white,
                borderRadius: theme.spacing(QUINTUPLE_DECILE),
                width: theme.spacing(TRIPLE),
            },
            "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
                background: alpha(theme.palette.primary.onFixedVariant, THUMB_OPACITY),
                borderRadius: theme.shape.borderRadius,
                border: `${theme.spacing(THUMB_BORDER_WIDTH_DEFAULT)} solid ${theme.palette.common.white}`,
                transition: theme.transitions.create("all", {
                    duration: theme.transitions.duration.complex,
                    easing: theme.transitions.easing.easeOut,
                }),
            },
            "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
                background: alpha(theme.palette.primary.onFixedVariant, THUMB_OPACITY_ON_HOVER),
                cursor: "grabbing",
            },
        },
    }),
};
